export default {
	init() {
		$('nav.actions ul li:last-child').attr('id','submit_button');
		/*$("#submit_button").on('click', function (event) { 			
        	setTimeout(function(){
				event.preventDefault();
        		var el = $(this);
        		el.prop('disabled', true);				
				//el.prop('disabled', false); 
			}, 100);
		}); */
		var rSubmitCount = 0;
		$('form#recommendation-form').on('submit',function (event) {
			//grechaptcha
			event.preventDefault();
			var that = this;//set that variable so it will be available in next function
			rSubmitCount++;
			if (rSubmitCount <=1 ) {//Prevent double-click
				if( $('#recaptchaResponse').length) {
					grecaptcha.ready(function () { 
						grecaptcha.execute('6Lerg-kUAAAAAOKHCBzpYMKugpr8WKG6fNPdhy6K', {action: 'register'}).then(function(token) {
							var recaptchaResponse = document.getElementById('recaptchaResponse'); 
							recaptchaResponse.value = token;
							
							$(that).off("submit"); // to guarantee the function won't be invoked
							that.submit();
						});
					});
				}
			}
		});

		/// Phone number masking http://igorescobar.github.io/jQuery-Mask-Plugin/docs.html
    	$('#applicant_phone').mask('000-000-0000');
		
		//add character count to recommendation form
		var maxLength = $('#pastor_question_9').attr('maxlength');
		$('#pastor_question_9').keyup(function() {
			var textlen = maxLength - $(this).val().length;
			$('#rchars span').text(textlen);
		});
	}
}